export const GTM_ID = {
    CONFIGURATION_SOUND_ON: 'features-calendar-configuration-soundon',
    CONFIGURATION_SOUND_OFF: 'features-calendar-configuration-soundoff',
    CONFIGURATION_DEFAULT_VIEW: 'features-calendar-configuration-defaultview',
    CONFIGURATION_PREMIUM_VIEW: 'features-calendar-configuration-premiumview',
    CONFIGURATION_BASIC_VIEW: 'features-calendar-configuration-basicview',
    CONFIGURATION_PREMIUM_LINK: "features-calendar-configuration-premiumlink",
    SUBSCRIPTION_TOP_EVENTS_SUBSCRIBE: "features-calendar-topevents-subscription",
    SUBSCRIPTION_TOP_EVENTS_UNSUBSCRIBE: "features-calendar-topevents-unsubscription",
    RELATED_EVENTS: "features-calendar-related-event-{relatedEventName}"
}
export const GA4EVENT = {
    NAMES: { FEATURES_CALENDAR: "features-calendar" },
    ELEMENTS: {
        CONFIGURATION_SOUND_ON: 'configuration-soundon',
        CONFIGURATION_SOUND_OFF: 'configuration-soundoff',
        CONFIGURATION_DEFAULT_VIEW: 'configuration-defaultview',
        CONFIGURATION_PREMIUM_VIEW: 'configuration-premiumview',
        CONFIGURATION_BASIC_VIEW: 'configuration-basicview',
        CONFIGURATION_PREMIUM_LINK: "configuration-premiumlink",
        SUBSCRIPTION_TOP_EVENTS_SUBSCRIBE: "topevents-subscription",
        SUBSCRIPTION_TOP_EVENTS_UNSUBSCRIBE: "topevents-unsubscription",
        RELATED_EVENTS: "related-event"
    }
}